/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversations_Search_Empty_TitleInputs */



/**
* | output |
* | --- |
* | "No conversations found" |
*
* @param {Conversations_Search_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const conversations_search_empty_title = /** @type {((inputs?: Conversations_Search_Empty_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversations_Search_Empty_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Geen gesprekken gevonden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune conversation trouvée")
	return /** @type {LocalizedString} */ ("No conversations found")
});